module.exports = __webpack_public_path__ + "img/a8.d6d37d27.jpg";